import React from "react";
import FetchHelper from "./lib/fetchHelper";
import { Modal } from "bootstrap";
import { confetti } from "@tsparticles/confetti";
import { ReactRenderer } from "./lib/ReactRenderer";
export default class MemberCelebrationComponent extends React.Component {
    constructor(props) {
        var _a, _b, _c;
        super(props);
        this.render = () => {
            return (React.createElement(React.Fragment, null, this.state.shouldCelebrate ? React.createElement(this.CelebrationModal, { header: this.state.message.header, message: this.state.message.message }) : React.createElement(React.Fragment, null)));
        };
        this.messages = {
            "ANNIVERSARY": { header: "Jubilæum!", "message": `Tillykke med dit ${(_a = this.props.currentMember) === null || _a === void 0 ? void 0 : _a.anniversary()} års jubilæum som frivillig i biografen! Dine frivilligkolleger og bestyrelsen takker for din indsats.` },
            "FIRST_LOGIN": { header: "Hej!", "message": "Velkommen som bruger af biografens intranet." }
        };
        this.state = {
            message: this.messages[(_b = this.props.currentMember) === null || _b === void 0 ? void 0 : _b.celebrationType()],
            shouldCelebrate: ((_c = this.props.currentMember) === null || _c === void 0 ? void 0 : _c.shouldCelebrate()) === 'true'
        };
    }
    componentDidMount() {
        if (this.state.shouldCelebrate) {
            this.celebrate();
        }
    }
    celebrate() {
        var modal = new Modal(document.getElementById('celebrationModal'));
        modal.show();
        this.doConfetti();
        FetchHelper.get("/bpapi/memberprofile/celebrated/");
    }
    doConfetti() {
        const duration = 5 * 1000;
        const defaultConfetti = {
            startVelocity: 30,
            spread: 360,
            ticks: 100,
            zIndex: 9999,
        };
        const starConfetti = {
            shapes: ["image", "star"],
            shapeOptions: {
                image: [
                    { src: "/img/dk.svg", width: 32, height: 24 }
                ],
            },
            colors: ["FFE400", "FFBD00", "E89400", "FFCA6C", "FDFFB8"],
        };
        const shapeConfetti = {
            shapes: ["image", "circle", "square"],
            shapeOptions: {
                image: [
                    { src: "/img/dk.svg", width: 32, height: 24 }
                ],
            },
            colors: ["C9072A", "FFFFFF"],
        };
        const randomInRange = (min, max) => Math.random() * (max - min) + min;
        const end = Date.now() + duration;
        const interval = setInterval(function () {
            const timeLeft = end - Date.now();
            if (timeLeft <= 0) {
                return clearInterval(interval);
            }
            const particleCount = 50 * (timeLeft / duration);
            // since particles fall down, start a bit higher than random
            confetti(Object.assign(Object.assign(Object.assign({}, defaultConfetti), (Math.random() > 0.66 ? starConfetti : shapeConfetti)), { particleCount, origin: { x: randomInRange(0.1, 0.9), y: Math.random() - 0.2 } }));
            confetti(Object.assign(Object.assign(Object.assign({}, defaultConfetti), (Math.random() > 0.66 ? starConfetti : shapeConfetti)), { particleCount, origin: { x: randomInRange(0.1, 0.9), y: Math.random() - 0.2 } }));
        }, 250);
    }
    CelebrationModal(props) {
        return (React.createElement("div", { className: "modal fade", id: "celebrationModal" },
            React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                React.createElement("div", { className: "modal-content" },
                    React.createElement("div", { className: "modal-header" },
                        React.createElement("h5", { className: "modal-title", id: "celebrationModalLabel" }, props.header),
                        React.createElement("button", { type: "button", className: "btn-close", "data-bs-dismiss": "modal" })),
                    React.createElement("div", { className: "modal-body" }, props.message)))));
    }
}
ReactRenderer.render("membercelebrationcomponent", (elem) => React.createElement(MemberCelebrationComponent, Object.assign({}, (elem.dataset), { currentMember: window.currentMember })));
